<template>
  <div id="txidphone" class="relativeItem">
    <!--手机验证-->
    <div class="phone" v-show="next === 0">
      <div class="inputshell flex-box">
        <span class="s1">手机号</span>
        <input type="number" placeholder="请输入手机号" maxlength="11" v-model="phone" />
      </div>
      <div class="inputshell flex-box">
        <span class="s1">图片验证码</span>
        <input type="text" placeholder="请输入图片验证码" v-model="imgcode" />
        <img :src="imgcodeurl" @click="getImgCode" />
      </div>
      <div class="inputshell flex-box">
        <span class="s1">验证码</span>
        <input type="number" placeholder="请输入验证码" v-model="yzm" />
        <span class="s2 commonBk" :class="{disable:!getCode}" @click="gcode">{{ codeText }}</span>
      </div>
    </div>

    <!--身份验证-->
    <div class="idcodeshell" v-show="next === 1">
      <p class="whiteB margin-b">
        1.拍摄清晰的身份证正反面照片，身份证号码、国徽、
        有效时期等信息清晰可见
      </p>

      <div class="imgshell flex-box whiteB">
        <div class="text">
          <span class="s1">
            身份证
            <i>人像面</i>
          </span>
          <span class="s2">点击上传身份证人像面</span>
        </div>

        <div class="img relativeItem">
          <img src="../../assets/idcode/img(3).png" />
          <img class="close absoluteItem" src="../../assets/idcode/img(1).png" />
          <img class="mainimg absoluteItem" src="../../assets/idcode/img(4).png" />
        </div>
      </div>

      <div class="imgshell flex-box whiteB">
        <div class="text">
          <span class="s1">
            身份证
            <i>国徽面</i>
          </span>
          <span class="s2">点击拍摄身份证国徽面</span>
        </div>

        <div class="img relativeItem">
          <img src="../../assets/idcode/img(3).png" />
          <img class="close absoluteItem" src="../../assets/idcode/img(1).png" />
          <img class="mainimg absoluteItem" src="../../assets/idcode/img(4).png" />
        </div>
      </div>

    </div>

    <!--提交按钮-->
    <div class="an absoluteItem overHidden commonBk centerX">
      <div class="allA"></div>
      {{ an_text }}
    </div>
  </div>
</template>






<script>
export default {
  name: "txidphone",
  components: {},
  data() {
    return {
      next: 0, //0验证手机 1验证身份证
      an_text: "下一步，身份验证",
      info: {}, //用户信息
      putId: false, //是否允许用户点击身份证登记确认按钮
      name: "", //姓名
      idcode: "", //身份证号码
      phone: "",
      yzm: "",
      imgcode: "", //图片验证码
      imgcodeurl: "",
      codeText: "获取验证码",
      getCode: false, //是否可以获取验证码
      is: 0 //判断是否需要提交电话还是身份好吗
    };
  },
  methods: {
    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("me"), data, res => {
        _this.info = res.data.data.result;
      });
    },
    //获取验证码
    gcode() {
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }
      let _this = this;
      let data = {
        phone: this.phone,
        code: this.imgcode.toLowerCase()
      };
      this.$jsonp(this.$apis("code"), data, res => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "已发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "发送验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else {
          _this.getCode = true;
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },
    /**获取图片yzm */
    getImgCode() {
      let _this = this;
      this.$jsonp(this.$apis("imgcode"), {}, res => {
        if (res.data.data.status == 200) {
          _this.imgcodeurl = res.data.data.data;
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },
    /**可以提交绑定资料的判断 */
    able_db() {
      if (this.is === 2) {
        //只有身份信息
        if (
          this.name != "" &&
          (this.idcode.length == 15 || this.idcode.length == 18)
        ) {
          this.putId = true;
        } else {
          this.putId = false;
        }
      } else if (this.is === 1) {
        //只要电话好吗
        if (
          this.$tool.checkPhone(this.phone) &&
          this.imgcode != "" &&
          this.yzm.length == 6
        ) {
          this.putId = true;
        } else {
          this.putId = false;
        }
      } else {
        //身份信息和电话都需要
        if (
          this.name != "" &&
          (this.idcode.length == 15 || this.idcode.length == 18) &&
          this.$tool.checkPhone(this.phone) &&
          this.imgcode != "" &&
          this.yzm.length == 6
        ) {
          this.putId = true;
        } else {
          this.putId = false;
        }
      }
    },
    /**提交身份信息 */
    putIdcode() {
      if (this.putId) {
        this.putId = false;
      }
      let data = {};
      if (this.is === 1) {
        //只要电话号码
        data.phone = this.phone;
        data.code = this.yzm;
      } else if (this.is === 2) {
        //只要身份信息
        data.card = this.idcode;
        data.name = this.name;
      } else {
        //身份信息和电话都需要
        data.card = this.idcode;
        data.name = this.name;
        data.phone = this.phone;
        data.code = this.yzm;
      }

      let _this = this;
      this.$jsonp(this.$apis("txIdcode"), data, res => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("登记成功");
          let su = setTimeout(() => {
            _this.showIdcode = false;
            clearTimeout(su);
          }, 1000);
        } else {
          _this.bdtext = res.data.data.msg;
          _this.putId = true;
        }
      });
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("信息提交");
    this.getImgCode();
    // this.getInfo();
  },
  watch: {
    // name() {
    //   this.able_db();
    // },
    // idcode() {
    //   this.able_db();
    // },
    yzm() {
      this.able_db();
    },
    phone() {
      this.able_db();
    },
    imgcode() {
      if (this.$tool.checkPhone(this.phone) && this.imgcode.length === 4) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    }
  }
};
</script>








<style scoped>
#txidphone {
  min-height: 100vh;
}
.allA {
  background: rgba(255, 255, 255, 0.5);
}
.an {
  border-radius: 1.875rem;
  width: 13.4375rem;
  height: 2.75rem;
  line-height: 2.75rem;
  font-size: 15px;
  color: white;
  text-align: center;
  bottom: 1.25rem;
}
.margin-b {
  margin-bottom: 1px;
}

/**手机验证 */
.inputshell {
  padding: 0.5rem 0.6rem;
  align-items: center;
  background: white;
  margin-bottom: 1px;
}
.inputshell .s1 {
  width: 25%;
  font-size: 15px;
}
.inputshell input {
  width: 42%;
  font-size: 15px;
  color: #333;
  height: 2.125rem;
  line-height: 2.125rem;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
.inputshell .s2,
.inputshell img {
  width: 7.5rem;
  height: 2.125rem;
}
.inputshell .s2 {
  line-height: 2.125rem;
  text-align: center;
  font-size: 14px;
  color: white;
  border-radius: 0.5rem;
}
.inputshell .disable {
  background: #e5e5e5;
}

/**身份验证 */
.idcodeshell p {
  font-size: 14px;
  text-align: justify;
  padding: 0.8rem;
}
.imgshell{
  padding: 1rem  0.8rem;
  justify-content: space-between;
  align-items: center;
}
.imgshell .s1,.imgshell i{
  font-style: normal;
  font-style: 15px;
  color: #DF71E1;
}

</style>
